import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertError16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_251)'>
      <path
        d='M9.06061 8L11.0303 9.96967L9.96961 11.0303L7.99995 9.06066L6.03027 11.0303L4.96961 9.96967L6.93929 8L4.96961 6.03033L6.03027 4.96967L7.99995 6.93934L9.96961 4.96967L11.0303 6.03033L9.06061 8Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_251'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AlertError16.displayName = 'AlertError16';
export default AlertError16;
